import { ICON_COLOR } from '../menu';

export default function Logout({ color = ICON_COLOR, size = 24 }) {
  return (
    <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M5 19H12C12.55 19 13 19.45 13 20C13 20.55 12.55 21 12 21H5C3.9 21 3 20.1 3 19V5C3 3.9 3.9 3 5 3H12C12.55 3 13 3.45 13 4C13 4.55 12.55 5 12 5H5V19Z'
        fill={color}
      />
      <path
        d='M16.3114 9.1C15.9214 8.71 15.9214 8.09 16.3114 7.7C16.7014 7.31 17.3214 7.31 17.7114 7.7L21.3014 11.3C21.6914 11.69 21.6914 12.32 21.3014 12.71L17.7114 16.3C17.3214 16.69 16.7014 16.69 16.3114 16.3C15.9214 15.91 15.9214 15.29 16.3114 14.9L18.2114 13H9.01138C8.46138 13 8.01138 12.55 8.01138 12C8.01138 11.45 8.46138 11 9.01138 11H18.2114L16.3114 9.1Z'
        fill={color}
      />
    </svg>
  );
}
